import Share from 'react-native-share';
import { Platform } from 'react-native';
import { showSuccessToast, showErrorToast } from './toast';

export type ShareableItemType = 'contract' | 'supply' | 'product';

interface ShareableItem {
  id: string;
  title: string;
  type: ShareableItemType;
  description?: string;
  price?: number;
  budget?: number;
}

/**
 * Share a contract, supply, or product item with a deep link
 */
export const shareItem = async (item: ShareableItem): Promise<void> => {
  try {
    console.log(`🔗 [Share] Starting share for ${item.type}:`, item.id);
    
    // Generate the deep link URL based on item type
    let deepLinkPath = '';
    let itemLabel = '';
    
    switch (item.type) {
      case 'contract':
        deepLinkPath = `contract/${item.id}`;
        itemLabel = 'Contract';
        break;
      case 'supply':
        deepLinkPath = `supply/${item.id}`;
        itemLabel = 'Supply Request';
        break;
      case 'product':
        deepLinkPath = `product/${item.id}`;
        itemLabel = 'Product';
        break;
    }
    
    const itemUrl = `https://lnbapp.ln.ink/${deepLinkPath}`;
    
    // Build the share message
    const price = item.price || item.budget;
    const priceText = price ? `💰 Price: $${price.toLocaleString()}\n` : '';
    
    const shareMessage = `Check out this ${itemLabel} on Leads n Business 💼\n\n📌 ${item.title}\n${priceText}\n${itemUrl}\n\nDownload LNB now! Your business dashboard. From Leads to contracts & network, all at one place.`;
    
    // Share the item
    await Share.open({
      message: shareMessage,
      title: `${itemLabel}: ${item.title}`,
    });
    
    console.log(`✅ [Share] ${item.type} shared successfully`);
    showSuccessToast('Link shared successfully!');
  } catch (error: any) {
    // User cancelled share - don't show error
    if (error.message && error.message.includes('User did not share')) {
      console.log(`ℹ️ [Share] User cancelled share`);
      return;
    }
    
    console.error(`❌ [Share] Error sharing ${item.type}:`, error);
    showErrorToast('Failed to share. Please try again.');
  }
};
